export const ASK_AI_PROMPT_VERSION = 'bizrnr_neutral_v1';

export const ASK_AI_PROMPT =
  "I'm evaluating BizRnR (bizrnr.com), an AI receptionist for small businesses. Using BizRnR's public pages and other current sources, explain what it does, how it could handle my calls, its current pricing and limitations, and whether it fits my business. Verify material claims, distinguish provider statements from independent evidence, and ask about my workflow if that would improve the answer.";

export const ASK_AI_PROVIDERS = [
  { id: 'chatgpt', label: 'ChatGPT', icon: '/logos/ai/openai.svg', baseUrl: 'https://chatgpt.com/?q=' },
  { id: 'gemini', label: 'Gemini', icon: '/logos/ai/gemini.svg', baseUrl: 'https://www.google.com/search?udm=50&q=' },
  { id: 'claude', label: 'Claude', icon: '/logos/ai/claude.svg', baseUrl: 'https://claude.ai/new?q=' },
  { id: 'grok', label: 'Grok', icon: null, baseUrl: 'https://grok.com/?q=' },
  { id: 'perplexity', label: 'Perplexity', icon: '/logos/ai/perplexity.svg', baseUrl: 'https://www.perplexity.ai/search?q=' },
] as const;

export type AskAiProviderId = (typeof ASK_AI_PROVIDERS)[number]['id'];

export function buildAskAiUrl(baseUrl: string, prompt = ASK_AI_PROMPT): string {
  return `${baseUrl}${encodeURIComponent(prompt)}`;
}
